export const PeriodFilterId = 'RepositoryPeriodFilter';
export const YearFilterId = 'RepositoryYearFilter';
export const CategoryFilterId = 'RepositoryCategoryFilter';
export const TitleFilterId = 'RepositoryTitleFilter';
